import {
  getStoreSyncConfigApi,
  updateStoreSyncConfigApi,
  synchronizeStoresApi,
  getStoreSyncProcessStatusApi,
  downloadStoreSyncRunReportCsvApi,
} from './store-synchronization.api';

import { ToastUtil } from '../utils/toast.util';

export const getStoreSyncConfigReducers = (builder) => {
  builder
    .addCase(getStoreSyncConfigApi.pending, (state) => {
      state.getStoreSyncConfigStatus = 'pending';
      state.error = null;
    })
    .addCase(getStoreSyncConfigApi.fulfilled, (state, action) => {
      state.getStoreSyncConfigStatus = 'fulfilled';
      state.syncConfig = action.payload;
      state.error = null;
    })
    .addCase(getStoreSyncConfigApi.rejected, (state, action) => {
      state.getStoreSyncConfigStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

export const updateStoreSyncConfigReducers = (builder) => {
  builder
    .addCase(updateStoreSyncConfigApi.pending, (state) => {
      state.updateStoreSyncConfigStatus = 'pending';
      state.error = null;
    })
    .addCase(updateStoreSyncConfigApi.fulfilled, (state, { payload }) => {
      state.updateStoreSyncConfigStatus = 'fulfilled';

      if (payload.success) {
        state.syncConfig = payload.data;
      }
      state.error = payload.message;

      ToastUtil.handleApiResponse(
        payload,
        'Synchronization schedule updated successfully',
        'Failed to update synchronization schedule',
      );
    })
    .addCase(updateStoreSyncConfigApi.rejected, (state, action) => {
      state.updateStoreSyncConfigStatus = 'rejected';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Update failed',
        action?.error?.message || 'Failed to update synchronization schedule',
      );
    });
};

export const synchronizeStoresReducers = (builder) => {
  builder
    .addCase(synchronizeStoresApi.pending, (state) => {
      state.synchronizeStoresStatus = 'pending';
      state.error = null;
    })
    .addCase(synchronizeStoresApi.fulfilled, (state, { payload }) => {
      state.synchronizeStoresStatus = 'fulfilled';
      state.lastSyncResult = payload.data || payload;
      state.isSyncRunning = true;
      state.error = payload.message;

      ToastUtil.handleApiResponse(
        payload,
        'Stores synchronization started successfully',
        'Store synchronization failed to start',
      );
    })
    .addCase(synchronizeStoresApi.rejected, (state, action) => {
      state.synchronizeStoresStatus = 'rejected';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Synchronization failed to start',
        action?.error?.message || 'Failed to start synchronization for stores',
      );
    });
};

export const storeSyncProgressReducers = (builder) => {
  builder
    .addCase(getStoreSyncProcessStatusApi.fulfilled, (state, { payload }) => {
      state.syncProcessStatus = payload;
      state.isSyncRunning = Boolean(payload?.isRunning);
    })
    .addCase(downloadStoreSyncRunReportCsvApi.pending, (state) => {
      state.downloadSyncReportStatus = 'loading';
    })
    .addCase(downloadStoreSyncRunReportCsvApi.fulfilled, (state) => {
      state.downloadSyncReportStatus = 'succeeded';
    })
    .addCase(downloadStoreSyncRunReportCsvApi.rejected, (state) => {
      state.downloadSyncReportStatus = 'failed';
    });
};